import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form'
import settings from './settings';

const reducers = {
  routing: routerReducer,
  settings,
  form: formReducer,
};

module.exports = combineReducers(reducers);



// WEBPACK FOOTER //
// ./reducers/index.js